import logoVrio from "~/assets/light-logo.png";

export default {
  title: "dark",

  colors: {
    logoVrio,

    primaryBackground: "#292828",
    primaryText: "#FFF",

    secondaryBackground: "#262525",
    secondaryText: "#FFF",

    thirdBackground: "#201F1F",
    thirdText: "#FFF",
  },
};
